import {createSlice} from '@reduxjs/toolkit'
import localStorageManager from '../../utils/localStorageManager'
import CustomerService from './../../api/customer'
import localStorageKeys from '../../utils/localStorageKeys'

export const sidebarSlice = createSlice({
    name: 'sidebar',
    initialState: {
        sidebarIsActive: true,
        customer: {},
        globalInfo: '',
        sessionIdExist: false,
        isDarkMode: localStorageManager.get(localStorageKeys.IS_DARK_MODE)
    },
    reducers: {
        toggleMobileSidebarStatus: (state) => {
            state.sidebarIsActive = !state.sidebarIsActive
        },
        toggleSidebar: (state) => {
            state.sidebarIsActive = !state.sidebarIsActive
        },
        setSidebarIsActive: (state, {payload}) => {
            state.sidebarIsActive = payload
            localStorage.setItem(localStorageKeys.IS_SIDEBAR_ACTIVE, payload)
        },
        setCustomerData: (state) => {
            state.customer = localStorageManager.get('customer')
        },
        setGlobalInfo: (state, {payload}) => {
            state.globalInfo = payload
        },
        setSessionIdExist: (state, {payload}) => {
            state.sessionIdExist = payload
        },
        setIsDarkMode: (state, {payload}) => {
            state.isDarkMode = payload
            localStorageManager.set(localStorageKeys.IS_DARK_MODE, payload)
        }
    }
})

export const {
    setCustomerData,
    toggleMobileSidebarStatus,
    toggleSidebar,
    setSidebarIsActive,
    setGlobalInfo,
    setSessionIdExist,
    setIsDarkMode
} = sidebarSlice.actions

export default sidebarSlice.reducer

export const getUpgradedPlan = () => {
    return async() => {
        let customerData = await CustomerService.getCustomerData()
        customerData = customerData.data.data
        localStorage.setItem('plan', customerData?.organisation?.plan)
        localStorageManager.set('limits', customerData?.limits)
    }
}
